import React from 'react';
import { RecordingClient } from '../index-types';
export default React.createContext<RecordingClient | null>(null);
